export default {
  setActiveStepForm (state, data) {
    state.activeStepForm = data
  }
}
